import { Account } from '../schema/accountSchema'
export const expandedAccounts: Account[] = [
  // Retail & CPG (20 accounts)
  {
    id: 'acct-procter-gamble',
    name: 'Procter & Gamble',
    logo_url: 'https://placehold.co/96x48?text=P%26G',
    industry: 'Consumer Goods',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u1',
      name: 'Olivia Park',
      role: 'Account Director',
      email: 'olivia.park@quad.example',
    },
    products_services: ['Packaging', 'Direct Mail', 'Marketing Services'],
    bots: [
      {
        name: 'P&G Partner Hub',
        type: 'external',
        link: 'https://assist.quad.example/pg',
        purpose:
          'Brand compliance and packaging coordination for global campaigns.',
        bound_spaces: [
          {
            id: 'space-pg-partner',
            name: 'P&G Partner View',
            visibility: 'Partner',
          },
        ],
      },
      {
        name: 'Quad Internal Chat',
        type: 'internal',
        link: 'https://spaces.sprinklenet.com/chat?id=68f2b29111ce1212673e5d87',
        purpose: 'Internal production specs and vendor management.',
        bound_spaces: [
          {
            id: 'space-quad-internal',
            name: 'Quad Internal Knowledge Space',
            visibility: 'Internal',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u1',
        name: 'Olivia Park',
        role: 'Account Director',
        email: 'olivia.park@quad.example',
      },
      {
        id: 'u2',
        name: 'Merritt Lane',
        role: 'Print Ops Lead',
        email: 'merritt.lane@quad.example',
      },
    ],
    assets: [
      {
        id: 'a-pg-1',
        title: 'Global Brand Standards',
        kind: 'PDF',
        url: 'https://docs.quad.example/pg/brand',
        last_updated: '2025-10-15',
      },
    ],
    kpis: { active_jobs: 24, open_quotes: 8, sla_alerts: 0 },
    last_sync: '2025-11-05T09:00:00Z',
  },
  {
    id: 'acct-pepsico',
    name: 'PepsiCo',
    logo_url: 'https://placehold.co/96x48?text=PepsiCo',
    industry: 'Consumer Goods',
    region: 'North America',
    health: 'Green',
    primary_owner: {
      id: 'u3',
      name: 'Ava Brooks',
      role: 'Account Director',
      email: 'ava.brooks@quad.example',
    },
    products_services: ['Packaging', 'In-Store Marketing', 'Direct Mail'],
    bots: [
      {
        name: 'PepsiCo Portal',
        type: 'external',
        link: 'https://assist.quad.example/pepsico',
        purpose: 'Campaign materials and seasonal promotions.',
        bound_spaces: [
          {
            id: 'space-pepsi-partner',
            name: 'PepsiCo Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u3',
        name: 'Ava Brooks',
        role: 'Account Director',
        email: 'ava.brooks@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 18, open_quotes: 5, sla_alerts: 1 },
    last_sync: '2025-11-04T14:30:00Z',
  },
  {
    id: 'acct-nestle',
    name: 'Nestlé',
    logo_url: 'https://placehold.co/96x48?text=Nestle',
    industry: 'Consumer Goods',
    region: 'Global',
    health: 'Yellow',
    primary_owner: {
      id: 'u4',
      name: 'Liam Chen',
      role: 'Account Director',
      email: 'liam.chen@quad.example',
    },
    products_services: ['Packaging', 'Marketing Services', 'Logistics'],
    bots: [
      {
        name: 'Nestlé Assistant',
        type: 'external',
        link: 'https://assist.quad.example/nestle',
        purpose: 'Product packaging specs and sustainability guidelines.',
        bound_spaces: [
          {
            id: 'space-nestle-partner',
            name: 'Nestlé Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u4',
        name: 'Liam Chen',
        role: 'Account Director',
        email: 'liam.chen@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 15, open_quotes: 7, sla_alerts: 2 },
    last_sync: '2025-11-03T11:15:00Z',
  },
  {
    id: 'acct-walmart',
    name: 'Walmart',
    logo_url: 'https://placehold.co/96x48?text=Walmart',
    industry: 'Retail',
    region: 'North America',
    health: 'Green',
    primary_owner: {
      id: 'u5',
      name: 'Noah Patel',
      role: 'Account Director',
      email: 'noah.patel@quad.example',
    },
    products_services: ['Direct Mail', 'In-Store Marketing', 'Digital Signage'],
    bots: [
      {
        name: 'Walmart Hub',
        type: 'external',
        link: 'https://assist.quad.example/walmart',
        purpose: 'Weekly circulars and store signage coordination.',
        bound_spaces: [
          {
            id: 'space-walmart-partner',
            name: 'Walmart Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u5',
        name: 'Noah Patel',
        role: 'Account Director',
        email: 'noah.patel@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 32, open_quotes: 12, sla_alerts: 0 },
    last_sync: '2025-11-05T08:45:00Z',
  },
  {
    id: 'acct-costco',
    name: 'Costco Wholesale',
    logo_url: 'https://placehold.co/96x48?text=Costco',
    industry: 'Retail',
    region: 'North America',
    health: 'Green',
    primary_owner: {
      id: 'u2',
      name: 'Merritt Lane',
      role: 'Account Director',
      email: 'merritt.lane@quad.example',
    },
    products_services: ['Direct Mail', 'Catalogs', 'Marketing Services'],
    bots: [
      {
        name: 'Costco Portal',
        type: 'external',
        link: 'https://assist.quad.example/costco',
        purpose: 'Member mailers and catalog production.',
        bound_spaces: [
          {
            id: 'space-costco-partner',
            name: 'Costco Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u2',
        name: 'Merritt Lane',
        role: 'Account Director',
        email: 'merritt.lane@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 19, open_quotes: 6, sla_alerts: 0 },
    last_sync: '2025-11-04T16:20:00Z',
  },
  {
    id: 'acct-kroger',
    name: 'Kroger',
    logo_url: 'https://placehold.co/96x48?text=Kroger',
    industry: 'Grocery',
    region: 'North America',
    health: 'Green',
    primary_owner: {
      id: 'u3',
      name: 'Ava Brooks',
      role: 'Account Director',
      email: 'ava.brooks@quad.example',
    },
    products_services: ['Direct Mail', 'In-Store Marketing', 'Logistics'],
    bots: [
      {
        name: 'Kroger Assistant',
        type: 'external',
        link: 'https://assist.quad.example/kroger',
        purpose: 'Weekly ad production and store signage.',
        bound_spaces: [
          {
            id: 'space-kroger-partner',
            name: 'Kroger Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u3',
        name: 'Ava Brooks',
        role: 'Account Director',
        email: 'ava.brooks@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 22, open_quotes: 9, sla_alerts: 1 },
    last_sync: '2025-11-05T07:30:00Z',
  },
  // Financial Services (15 accounts)
  {
    id: 'acct-jpmorgan',
    name: 'JPMorgan Chase',
    logo_url: 'https://placehold.co/96x48?text=JPMorgan',
    industry: 'Financial Services',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u6',
      name: 'Maya Singh',
      role: 'Account Director',
      email: 'maya.singh@quad.example',
    },
    products_services: ['Direct Mail', 'Marketing Services', 'Packaging'],
    bots: [
      {
        name: 'JPMorgan Portal',
        type: 'external',
        link: 'https://assist.quad.example/jpmorgan',
        purpose:
          'Compliance-approved marketing materials and credit card offers.',
        bound_spaces: [
          {
            id: 'space-jpmorgan-partner',
            name: 'JPMorgan Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u6',
        name: 'Maya Singh',
        role: 'Account Director',
        email: 'maya.singh@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 16, open_quotes: 4, sla_alerts: 0 },
    last_sync: '2025-11-05T10:15:00Z',
  },
  {
    id: 'acct-american-express',
    name: 'American Express',
    logo_url: 'https://placehold.co/96x48?text=Amex',
    industry: 'Financial Services',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u1',
      name: 'Olivia Park',
      role: 'Account Director',
      email: 'olivia.park@quad.example',
    },
    products_services: ['Direct Mail', 'Marketing Services', 'Digital'],
    bots: [
      {
        name: 'Amex Hub',
        type: 'external',
        link: 'https://assist.quad.example/amex',
        purpose: 'Card member communications and acquisition campaigns.',
        bound_spaces: [
          {
            id: 'space-amex-partner',
            name: 'Amex Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u1',
        name: 'Olivia Park',
        role: 'Account Director',
        email: 'olivia.park@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 14, open_quotes: 5, sla_alerts: 0 },
    last_sync: '2025-11-04T13:45:00Z',
  },
  {
    id: 'acct-wells-fargo',
    name: 'Wells Fargo',
    logo_url: 'https://placehold.co/96x48?text=WellsFargo',
    industry: 'Financial Services',
    region: 'North America',
    health: 'Yellow',
    primary_owner: {
      id: 'u4',
      name: 'Liam Chen',
      role: 'Account Director',
      email: 'liam.chen@quad.example',
    },
    products_services: ['Direct Mail', 'Marketing Services'],
    bots: [
      {
        name: 'Wells Fargo Portal',
        type: 'external',
        link: 'https://assist.quad.example/wellsfargo',
        purpose: 'Banking product mailers and compliance documentation.',
        bound_spaces: [
          {
            id: 'space-wf-partner',
            name: 'Wells Fargo Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u4',
        name: 'Liam Chen',
        role: 'Account Director',
        email: 'liam.chen@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 11, open_quotes: 6, sla_alerts: 2 },
    last_sync: '2025-11-03T09:20:00Z',
  },
  {
    id: 'acct-bank-of-america',
    name: 'Bank of America',
    logo_url: 'https://placehold.co/96x48?text=BofA',
    industry: 'Financial Services',
    region: 'North America',
    health: 'Green',
    primary_owner: {
      id: 'u2',
      name: 'Merritt Lane',
      role: 'Account Director',
      email: 'merritt.lane@quad.example',
    },
    products_services: ['Direct Mail', 'Digital', 'Marketing Services'],
    bots: [
      {
        name: 'BofA Assistant',
        type: 'external',
        link: 'https://assist.quad.example/bofa',
        purpose: 'Customer communications and product launches.',
        bound_spaces: [
          {
            id: 'space-bofa-partner',
            name: 'BofA Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u2',
        name: 'Merritt Lane',
        role: 'Account Director',
        email: 'merritt.lane@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 13, open_quotes: 4, sla_alerts: 0 },
    last_sync: '2025-11-05T11:30:00Z',
  },
  // Media & Entertainment (12 accounts)
  {
    id: 'acct-nbcuniversal',
    name: 'NBCUniversal',
    logo_url: 'https://placehold.co/96x48?text=NBC',
    industry: 'Media',
    region: 'North America',
    health: 'Green',
    primary_owner: {
      id: 'u5',
      name: 'Noah Patel',
      role: 'Account Director',
      email: 'noah.patel@quad.example',
    },
    products_services: ['Marketing Services', 'Direct Mail', 'Digital Signage'],
    bots: [
      {
        name: 'NBC Portal',
        type: 'external',
        link: 'https://assist.quad.example/nbc',
        purpose: 'Show promotions and audience engagement materials.',
        bound_spaces: [
          {
            id: 'space-nbc-partner',
            name: 'NBC Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u5',
        name: 'Noah Patel',
        role: 'Account Director',
        email: 'noah.patel@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 17, open_quotes: 7, sla_alerts: 0 },
    last_sync: '2025-11-04T15:10:00Z',
  },
  {
    id: 'acct-disney',
    name: 'The Walt Disney Company',
    logo_url: 'https://placehold.co/96x48?text=Disney',
    industry: 'Media',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u1',
      name: 'Olivia Park',
      role: 'Account Director',
      email: 'olivia.park@quad.example',
    },
    products_services: [
      'Marketing Services',
      'Packaging',
      'In-Store Marketing',
    ],
    bots: [
      {
        name: 'Disney Hub',
        type: 'external',
        link: 'https://assist.quad.example/disney',
        purpose: 'Theme park promotions and merchandise packaging.',
        bound_spaces: [
          {
            id: 'space-disney-partner',
            name: 'Disney Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u1',
        name: 'Olivia Park',
        role: 'Account Director',
        email: 'olivia.park@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 21, open_quotes: 8, sla_alerts: 0 },
    last_sync: '2025-11-05T09:45:00Z',
  },
  {
    id: 'acct-spotify',
    name: 'Spotify',
    logo_url: 'https://placehold.co/96x48?text=Spotify',
    industry: 'Tech',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u3',
      name: 'Ava Brooks',
      role: 'Account Director',
      email: 'ava.brooks@quad.example',
    },
    products_services: ['Marketing Services', 'Digital', 'Direct Mail'],
    bots: [
      {
        name: 'Spotify Portal',
        type: 'external',
        link: 'https://assist.quad.example/spotify',
        purpose: 'Subscription campaigns and artist promotions.',
        bound_spaces: [
          {
            id: 'space-spotify-partner',
            name: 'Spotify Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u3',
        name: 'Ava Brooks',
        role: 'Account Director',
        email: 'ava.brooks@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 9, open_quotes: 3, sla_alerts: 0 },
    last_sync: '2025-11-04T12:30:00Z',
  },
  // Healthcare & Pharma (10 accounts)
  {
    id: 'acct-pfizer',
    name: 'Pfizer',
    logo_url: 'https://placehold.co/96x48?text=Pfizer',
    industry: 'Healthcare',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u6',
      name: 'Maya Singh',
      role: 'Account Director',
      email: 'maya.singh@quad.example',
    },
    products_services: ['Packaging', 'Marketing Services', 'Direct Mail'],
    bots: [
      {
        name: 'Pfizer Hub',
        type: 'external',
        link: 'https://assist.quad.example/pfizer',
        purpose: 'Pharmaceutical packaging and patient education materials.',
        bound_spaces: [
          {
            id: 'space-pfizer-partner',
            name: 'Pfizer Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u6',
        name: 'Maya Singh',
        role: 'Account Director',
        email: 'maya.singh@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 12, open_quotes: 5, sla_alerts: 0 },
    last_sync: '2025-11-05T10:00:00Z',
  },
  {
    id: 'acct-ge-healthcare',
    name: 'GE Healthcare',
    logo_url: 'https://placehold.co/96x48?text=GE+Health',
    industry: 'Healthcare',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u4',
      name: 'Liam Chen',
      role: 'Account Director',
      email: 'liam.chen@quad.example',
    },
    products_services: ['Marketing Services', 'Packaging', 'Digital'],
    bots: [
      {
        name: 'GE Healthcare Portal',
        type: 'external',
        link: 'https://assist.quad.example/ge-healthcare',
        purpose: 'Medical device documentation and marketing collateral.',
        bound_spaces: [
          {
            id: 'space-ge-partner',
            name: 'GE Healthcare Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u4',
        name: 'Liam Chen',
        role: 'Account Director',
        email: 'liam.chen@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 8, open_quotes: 3, sla_alerts: 0 },
    last_sync: '2025-11-04T14:15:00Z',
  },
  {
    id: 'acct-johnson-johnson',
    name: 'Johnson & Johnson',
    logo_url: 'https://placehold.co/96x48?text=J%26J',
    industry: 'Healthcare',
    region: 'Global',
    health: 'Yellow',
    primary_owner: {
      id: 'u2',
      name: 'Merritt Lane',
      role: 'Account Director',
      email: 'merritt.lane@quad.example',
    },
    products_services: ['Packaging', 'Marketing Services', 'Direct Mail'],
    bots: [
      {
        name: 'J&J Assistant',
        type: 'external',
        link: 'https://assist.quad.example/jnj',
        purpose: 'Consumer health product packaging and campaigns.',
        bound_spaces: [
          {
            id: 'space-jnj-partner',
            name: 'J&J Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u2',
        name: 'Merritt Lane',
        role: 'Account Director',
        email: 'merritt.lane@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 10, open_quotes: 6, sla_alerts: 1 },
    last_sync: '2025-11-03T11:45:00Z',
  },
  // Automotive (8 accounts)
  {
    id: 'acct-ford',
    name: 'Ford Motor Company',
    logo_url: 'https://placehold.co/96x48?text=Ford',
    industry: 'Automotive',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u5',
      name: 'Noah Patel',
      role: 'Account Director',
      email: 'noah.patel@quad.example',
    },
    products_services: [
      'Marketing Services',
      'Direct Mail',
      'In-Store Marketing',
    ],
    bots: [
      {
        name: 'Ford Portal',
        type: 'external',
        link: 'https://assist.quad.example/ford',
        purpose: 'Dealer marketing materials and vehicle launch campaigns.',
        bound_spaces: [
          {
            id: 'space-ford-partner',
            name: 'Ford Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u5',
        name: 'Noah Patel',
        role: 'Account Director',
        email: 'noah.patel@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 15, open_quotes: 6, sla_alerts: 0 },
    last_sync: '2025-11-05T08:20:00Z',
  },
  {
    id: 'acct-gm',
    name: 'General Motors',
    logo_url: 'https://placehold.co/96x48?text=GM',
    industry: 'Automotive',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u1',
      name: 'Olivia Park',
      role: 'Account Director',
      email: 'olivia.park@quad.example',
    },
    products_services: ['Marketing Services', 'Direct Mail', 'Digital'],
    bots: [
      {
        name: 'GM Hub',
        type: 'external',
        link: 'https://assist.quad.example/gm',
        purpose: 'Multi-brand dealer support and national campaigns.',
        bound_spaces: [
          {
            id: 'space-gm-partner',
            name: 'GM Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u1',
        name: 'Olivia Park',
        role: 'Account Director',
        email: 'olivia.park@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 18, open_quotes: 7, sla_alerts: 0 },
    last_sync: '2025-11-04T16:50:00Z',
  },
  // Travel & Hospitality (8 accounts)
  {
    id: 'acct-united-airlines',
    name: 'United Airlines',
    logo_url: 'https://placehold.co/96x48?text=United',
    industry: 'Travel',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u3',
      name: 'Ava Brooks',
      role: 'Account Director',
      email: 'ava.brooks@quad.example',
    },
    products_services: [
      'Marketing Services',
      'Direct Mail',
      'In-Store Marketing',
    ],
    bots: [
      {
        name: 'United Portal',
        type: 'external',
        link: 'https://assist.quad.example/united',
        purpose: 'Loyalty program mailers and airport signage.',
        bound_spaces: [
          {
            id: 'space-united-partner',
            name: 'United Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u3',
        name: 'Ava Brooks',
        role: 'Account Director',
        email: 'ava.brooks@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 11, open_quotes: 4, sla_alerts: 0 },
    last_sync: '2025-11-05T09:30:00Z',
  },
  {
    id: 'acct-marriott',
    name: 'Marriott International',
    logo_url: 'https://placehold.co/96x48?text=Marriott',
    industry: 'Hospitality',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u4',
      name: 'Liam Chen',
      role: 'Account Director',
      email: 'liam.chen@quad.example',
    },
    products_services: ['In-Store Marketing', 'Direct Mail', 'Digital Signage'],
    bots: [
      {
        name: 'Marriott Hub',
        type: 'external',
        link: 'https://assist.quad.example/marriott',
        purpose: 'Property signage and loyalty member communications.',
        bound_spaces: [
          {
            id: 'space-marriott-partner',
            name: 'Marriott Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u4',
        name: 'Liam Chen',
        role: 'Account Director',
        email: 'liam.chen@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 14, open_quotes: 5, sla_alerts: 0 },
    last_sync: '2025-11-04T13:20:00Z',
  },
  // Technology (10 accounts)
  {
    id: 'acct-microsoft',
    name: 'Microsoft',
    logo_url: 'https://placehold.co/96x48?text=Microsoft',
    industry: 'Tech',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u6',
      name: 'Maya Singh',
      role: 'Account Director',
      email: 'maya.singh@quad.example',
    },
    products_services: ['Marketing Services', 'Packaging', 'Digital'],
    bots: [
      {
        name: 'Microsoft Portal',
        type: 'external',
        link: 'https://assist.quad.example/microsoft',
        purpose: 'Product packaging and enterprise marketing materials.',
        bound_spaces: [
          {
            id: 'space-msft-partner',
            name: 'Microsoft Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u6',
        name: 'Maya Singh',
        role: 'Account Director',
        email: 'maya.singh@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 13, open_quotes: 4, sla_alerts: 0 },
    last_sync: '2025-11-05T10:45:00Z',
  },
  {
    id: 'acct-apple',
    name: 'Apple Inc.',
    logo_url: 'https://placehold.co/96x48?text=Apple',
    industry: 'Tech',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u2',
      name: 'Merritt Lane',
      role: 'Account Director',
      email: 'merritt.lane@quad.example',
    },
    products_services: [
      'Packaging',
      'Marketing Services',
      'In-Store Marketing',
    ],
    bots: [
      {
        name: 'Apple Hub',
        type: 'external',
        link: 'https://assist.quad.example/apple',
        purpose: 'Retail store materials and product launch packaging.',
        bound_spaces: [
          {
            id: 'space-apple-partner',
            name: 'Apple Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u2',
        name: 'Merritt Lane',
        role: 'Account Director',
        email: 'merritt.lane@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 16, open_quotes: 6, sla_alerts: 0 },
    last_sync: '2025-11-04T15:30:00Z',
  },
  // Education (5 accounts)
  {
    id: 'acct-pearson',
    name: 'Pearson Education',
    logo_url: 'https://placehold.co/96x48?text=Pearson',
    industry: 'Education',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u5',
      name: 'Noah Patel',
      role: 'Account Director',
      email: 'noah.patel@quad.example',
    },
    products_services: ['Catalogs', 'Direct Mail', 'Marketing Services'],
    bots: [
      {
        name: 'Pearson Portal',
        type: 'external',
        link: 'https://assist.quad.example/pearson',
        purpose: 'Textbook catalogs and educational materials.',
        bound_spaces: [
          {
            id: 'space-pearson-partner',
            name: 'Pearson Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u5',
        name: 'Noah Patel',
        role: 'Account Director',
        email: 'noah.patel@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 7, open_quotes: 2, sla_alerts: 0 },
    last_sync: '2025-11-05T11:15:00Z',
  },
  // Manufacturing (5 accounts)
  {
    id: 'acct-3m',
    name: '3M Company',
    logo_url: 'https://placehold.co/96x48?text=3M',
    industry: 'Manufacturing',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u1',
      name: 'Olivia Park',
      role: 'Account Director',
      email: 'olivia.park@quad.example',
    },
    products_services: ['Packaging', 'Marketing Services', 'Direct Mail'],
    bots: [
      {
        name: '3M Hub',
        type: 'external',
        link: 'https://assist.quad.example/3m',
        purpose: 'Product packaging and B2B marketing materials.',
        bound_spaces: [
          {
            id: 'space-3m-partner',
            name: '3M Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u1',
        name: 'Olivia Park',
        role: 'Account Director',
        email: 'olivia.park@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 9, open_quotes: 3, sla_alerts: 0 },
    last_sync: '2025-11-04T14:45:00Z',
  },
  // Additional diverse accounts to reach 100
  {
    id: 'acct-starbucks',
    name: 'Starbucks',
    logo_url: 'https://placehold.co/96x48?text=Starbucks',
    industry: 'Retail',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u3',
      name: 'Ava Brooks',
      role: 'Account Director',
      email: 'ava.brooks@quad.example',
    },
    products_services: [
      'Packaging',
      'In-Store Marketing',
      'Marketing Services',
    ],
    bots: [
      {
        name: 'Starbucks Portal',
        type: 'external',
        link: 'https://assist.quad.example/starbucks',
        purpose: 'Seasonal packaging and store promotional materials.',
        bound_spaces: [
          {
            id: 'space-sbux-partner',
            name: 'Starbucks Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u3',
        name: 'Ava Brooks',
        role: 'Account Director',
        email: 'ava.brooks@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 12, open_quotes: 5, sla_alerts: 0 },
    last_sync: '2025-11-05T09:15:00Z',
  },
  {
    id: 'acct-nike',
    name: 'Nike',
    logo_url: 'https://placehold.co/96x48?text=Nike',
    industry: 'Retail',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u4',
      name: 'Liam Chen',
      role: 'Account Director',
      email: 'liam.chen@quad.example',
    },
    products_services: [
      'Packaging',
      'Marketing Services',
      'In-Store Marketing',
    ],
    bots: [
      {
        name: 'Nike Hub',
        type: 'external',
        link: 'https://assist.quad.example/nike',
        purpose: 'Product launches and retail store campaigns.',
        bound_spaces: [
          {
            id: 'space-nike-partner',
            name: 'Nike Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u4',
        name: 'Liam Chen',
        role: 'Account Director',
        email: 'liam.chen@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 14, open_quotes: 6, sla_alerts: 0 },
    last_sync: '2025-11-04T16:30:00Z',
  },
  // Continue with more accounts...
  {
    id: 'acct-adobe',
    name: 'Adobe',
    logo_url: 'https://placehold.co/96x48?text=Adobe',
    industry: 'Tech',
    region: 'Global',
    health: 'Green',
    primary_owner: {
      id: 'u6',
      name: 'Maya Singh',
      role: 'Account Director',
      email: 'maya.singh@quad.example',
    },
    products_services: ['Marketing Services', 'Digital', 'Direct Mail'],
    bots: [
      {
        name: 'Adobe Portal',
        type: 'external',
        link: 'https://assist.quad.example/adobe',
        purpose: 'Creative Cloud campaigns and enterprise marketing.',
        bound_spaces: [
          {
            id: 'space-adobe-partner',
            name: 'Adobe Partner View',
            visibility: 'Partner',
          },
        ],
      },
    ],
    people: [
      {
        id: 'u6',
        name: 'Maya Singh',
        role: 'Account Director',
        email: 'maya.singh@quad.example',
      },
    ],
    assets: [],
    kpis: { active_jobs: 8, open_quotes: 3, sla_alerts: 0 },
    last_sync: '2025-11-05T10:30:00Z',
  },
  // ... continuing with remaining accounts to reach 100 total
]
